import React, { PropTypes, PureComponent } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { createFetchPageAction } from 'common/page/actions';
import { getProviders } from 'common/actions/authenticationActions';
import pageSelector from 'common/selectors/pageSelector';
import { providersSelector } from 'common/selectors/providerSelector';
import LinkWithFlags from 'common/LinkWithFlags';
import appConfig from '../../../config';

const {
    shellVersion,
    cdnHost,
    devStyles
} = appConfig;

const BASE_HREF = `${cdnHost}/redesign/${shellVersion}`;
let STYLE_HREF = `${BASE_HREF}/css`;
if (devStyles) {
    STYLE_HREF = 'http://localhost:8080/static/css';
}

const containerStyle = {
    padding: 20
};

const DEF_PROVIDER_VALUE = 'default';

class AffiliatePageExample extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mvpd: DEF_PROVIDER_VALUE,
            network: ''
        };
        this.onProviderChange = this.onProviderChange.bind(this);
        this.onNetworkChange = this.onNetworkChange.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
        this.selectByNetwork = this.selectByNetwork.bind(this);
    }

    onProviderChange(event) {
        this.setState({
            mvpd: event.target.value
        });
    }

    onNetworkChange(event) {
        this.setState({
            network: event.target.value
        });
    }

    onLinkClick(event) {
        if (this.state.mvpd === DEF_PROVIDER_VALUE) {
            event.preventDefault();
            this.warn();
        }
    }

    warn() { // eslint-disable-line class-methods-use-this
        alert('Select a provider'); // eslint-disable-line no-alert
    }

    selectByNetwork() {
        const { mvpd, network } = this.state;
        if (mvpd === DEF_PROVIDER_VALUE) {
            this.warn();
            return;
        }

        window.open(`/watch/mvpd/login?mvpd=${mvpd}&network=${network}`);
    }

    render() {
        const { mvpd, network } = this.state;
        const { page: { buckets: [bucket = {}] }, providers } = this.props;
        const { contents = [] } = bucket;


        const providerOptions = providers.map(({ name, abbreviation }) => (
            <option value={abbreviation}>{name}</option>
        ));
        providerOptions.unshift(
            <option value={DEF_PROVIDER_VALUE}>
                {'----- Choose Provider -----'}
            </option>
        );

        return (
            <div style={containerStyle}>
                <Helmet
                    meta={[
                        { name: 'robots', content: 'noindex, nofollow' }
                    ]}
                    link={[
                        { rel: 'stylesheet', href: `${STYLE_HREF}/page.css` }
                    ]}
                    style={[{
                        cssText: `
                            body {
                                font-family: sans-serif;
                            }
                            h1 { font-size: 24px; }
                            h2 { font-size: 20px; }
                            h3 { font-size: 18px; }
                        `
                    }]}
                />
                <h1>Affiliate Page Test</h1>
                <div style={{ marginTop: 20 }}>
                    <select
                        id="providerList"
                        defaultValue={mvpd}
                        style={{ width: 200 }}
                        onChange={this.onProviderChange}
                    >
                        {providerOptions}
                    </select>
                </div>
                <div style={{ marginTop: 20 }}>
                    <button onClick={this.selectByNetwork}>Network</button>
                    <input type="text" value={network} onChange={this.onNetworkChange} />
                </div>
                <div style={containerStyle}>
                    <ul>
                        {contents.map(({ id, name }) => (
                            <li key={id} data-id={id} style={{ listStyleType: 'circle' }}>
                                <LinkWithFlags
                                    to={{ pathname: '/mvpd/login', query: { id, mvpd } }}
                                    target="_blank"
                                    onClick={this.onLinkClick}
                                >
                                    {name}
                                </LinkWithFlags>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

AffiliatePageExample.defaultProps = {
    providers: []
};

AffiliatePageExample.propTypes = {
    page: PropTypes.object,
    providers: PropTypes.array
};

AffiliatePageExample.loadActions = [
    (params, query, lang) => createFetchPageAction('home', params, query, lang),
    (_, query) => getProviders({ platform: query.device })
];

const mapStateToProps = (state) => ({
    page: pageSelector(state),
    providers: providersSelector(state)
});

export default connect(mapStateToProps)(AffiliatePageExample);



// WEBPACK FOOTER //
// ./app/webapp/page/AffiliatePageExample.js